<template>
  <movable-area style="height: 100%; width: 100%;pointer-events: none;" class="serverBox" >
    <movable-view style="height: 100px; width: 50px;pointer-events: auto;"  x="600rpx" y="800rpx" direction="all" class="yuanshu">
      <!-- <a href="tel:4007781600" ref="telPhone" class="phone">
        <span class="telPhone">
          <img class="serviceIcon" ref="serviceIcon" src="./hotline.png" />
        </span>
      </a> 
      <view class="kefu" @click="toCustomerService">
        <span v-if="infoTotal" class="infoMsg">{{ infoTotal }}</span>
        <img class="serviceIcon" ref="serviceIcon" src="./online.png" />
        <img class="serviceIcon" ref="serviceIcon" src="./online.png" />
      </view>-->
      <view  @click="toqun" v-if="!isMovieZone&&!isqy">
        <img  ref="serviceIcon" src="./toqun.png"  style="width:140rpx;"/>
      </view>
      <view  @click="duihuan" v-if="isMovieZone">
        <img  ref="serviceIcon" src="./movie.png"  style="width:140rpx;"/>
      </view>
      <view  @click="zjyylog" v-if="!isMovieZone&&isqy">
        <img  ref="serviceIcon" src="./zjyylog.png"  style="width:140rpx;"/>
      </view>
    </movable-view>
  </movable-area>
</template>
<script>
import sheep from "@/sheep";
import { isWebView } from "@/utils/common";
import wx from 'weixin-js-sdk'

export default {
  name: 'cusService',
  props: {
    isMovieZone: {
      type: [String, Boolean],
      default:false,
    },
    isqy: {
      type: [String, Boolean],
      default:false,
    },
  },
  data() {
    return {
      oldMousePos: {}, // 手指原始位置
      oldNodePos: {}, // 元素原始位置
      infoTotal: 0,
      offsetL: `calc(100% - 60px)`,
      offsetR: `calc(100% - 200px)`,
      userId: uni.getStorageSync('userId') || '',
      userInfo: uni.getStorageSync('user-store')
        ? JSON.parse(uni.getStorageSync('user-store'))
        : {},
      activityId:'',  
      Source:'', 
      templateId: 6681353,
    };
  },
  computed: {},
  created() {
    this.activityId = uni.getStorageSync('activityId') || ''
    this.Source = uni.getStorageSync("Source")||''
  },
  mounted() {
    //  获取未读消息
    if (!this.userId) return;
    const that = this;
    if(!ysf) return
    setTimeout(() => {
      ysf('onunread', function (result) {
        that.infoTotal = result.total || 0;
        if (that.infoTotal > 9) that.infoTotal = 9;
      });
    }, 2000);
  },
  methods: {
    toqun(){
      if (!uni.getStorageSync("token")) {
        if (isWebView()) {
          uni.showModal({
						title: '游客模式暂不支持该功能',
						content: '完成登录后可使用商城完整功能',
						cancelText: '继续体验',
						confirmText: '去登录',
						success: async res => {
							if (res.confirm) {
								wx.miniProgram.navigateTo({
									url: '/pages/login/index'
								})
							}
						}
					});
        } else {
          sheep.$router.go('/pages/author/index')
        }
        return
      }
      if (isWebView()) {
        wx.miniProgram.navigateTo({
          url: '/pages/choujiang/index'
        })
      } else {
        sheep.$router.go('/pages/choujiang/index')
      }
     
    },
    duihuan(){
      this.$emit("duihuan")
    },
    zjyylog(){
      this.$emit("zjyylog")
    },
    // toCustomerService,
    /* 在线客服 */
    toCustomerService() {
      if(!ysf) return
      const that = this   
      if(!this.userId){
        this.userId = this.userInfo.userInfo.mobile
      }
      if(!this.userId){
        this.userId = uni.getStorageSync('serviceId')
      }
      ysf('config', {
        uid: this.userId || '',
        name: this.userInfo.userInfo?'C端--' + this.userInfo.userInfo.nickname : 'C端--游客',
        email: '',
        mobile: this.userInfo.userInfo?this.userInfo.userInfo.mobile : '',
        qtype: 6672728, // 常见问题模板
        success: function () {
          ysf('open',{templateId:that.templateId});
        },
      });
    },

    /* 拖拽客服开始 */
    touchstart(ev) {
      const selectDom = ev.currentTarget;
      // ev.preventDefault();
      const { pageX, pageY } = ev.touches[0]; // 手指位置
      const { offsetLeft, offsetTop } = selectDom; // 元素位置

      // 手指原始位置
      this.oldMousePos = {
        x: pageX,
        y: pageY,
      };

      // 元素原始位置
      this.oldNodePos = {
        x: offsetLeft,
        y: offsetTop,
      };

      this.offsetL = `${offsetLeft}px`;
      this.offsetR = `${offsetTop}px`;
    },

    /* 拖拽客服移动 */
    touchMove(ev) {
      const selectDom = ev.currentTarget;
      const lefts = this.oldMousePos.x - this.oldNodePos.x; // x轴偏移量
      const tops = this.oldMousePos.y - this.oldNodePos.y; // y轴偏移量
      const { pageX, pageY } = ev.touches[0]; // 手指位置

      this.offsetL = `${pageX - lefts}px`;
      this.offsetR = `${pageY - tops}px`;
    },

    /* 拖拽客服结束 */
    touchEnd(ev) {
      const selectDom = ev.currentTarget;
      const { clientWidth, clientHeight } = document.body;
      const { offsetLeft, offsetTop } = selectDom;
      if (offsetLeft < 50) {
        // 偏左
        this.offsetL = `0px`;
      }
      if (offsetLeft > clientWidth - 50) {
        // 偏右
        this.offsetL = `${clientWidth - 50}px`;
      }
      if (offsetTop < 50) {
        // 偏上
        this.offsetR = `0px`;
      }
      if (offsetTop > clientHeight - 50) {
        // 偏下
        this.offsetR = `${clientHeight - 50}px`;
      }
    },
  },
};
</script>

<style lang="scss">
.serverBox {
  width: 100%;
  height: 100%;
  position: fixed;
  top:0;
  left: 0;
  z-index: 99;
  .phone {
    width: 46px;
    height: 46px;
    .telPhone {
      width: 46px;
      height: 46px;
      display: inline-block;
      background: linear-gradient(180deg, #fe888f 0%, #f72537 70%);

      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    img {
      width: 42px;
    }
  }
  .kefu {
    margin-top: 5px;
    position: relative;
    width: 46px;
    height: 46px;
    background: linear-gradient(180deg, #fe888f 0%, #f72537 70%);


    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 42px;
    }
    .infoMsg {
      position: absolute;
      top: 0;
      right: 5px;
      background: #f00;
      color: #fff;
      font-size: 10px;
      width: 16px;
      height: 16px;
      line-height: 16px;
      border-radius: 50%;
      text-align: center;
    }
  }
}
</style>
